import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const followersEvolutionConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.facebook.page_followers_evolution',
    id: 'followers_evolution',
    icon: {
        name: 'followers',
        style: colors.purple
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    tooltip: 'kpi.facebook.tooltip_followers_evolution',
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    type: 'kpi',
    orientation: ORIENTATION_VERTICAL,
    element: KPIDefault,
    loader: DefaultLoader
};
